import React from 'react';
import { useNavigate } from 'react-router-dom';

const EmailVerificationPage: React.FC = () => {
  const navigate = useNavigate();

  return (
    <div style={{ minHeight: '80vh', display: 'flex', alignItems: 'center', justifyContent: 'center', padding: '2rem' }}>
      <div className="card" style={{ width: '100%', maxWidth: '500px', textAlign: 'center' }}>
        <div style={{ fontSize: '3rem', color: '#007bff', marginBottom: '1rem' }}>📧</div>
        <h2 style={{ color: '#007bff' }}>Check Your Email</h2>
        <p style={{ color: '#666', marginBottom: '2rem' }}>
          We've sent a verification email to your address from <strong>book@cybermed.ai</strong>.
        </p>
        <div className="alert alert-info" style={{ marginBottom: '2rem' }}>
          <strong>Next Steps:</strong>
          <ol style={{ textAlign: 'left', marginTop: '1rem', marginBottom: 0 }}>
            <li>Check your email inbox</li>
            <li>Look for an email from book@cybermed.ai</li>
            <li>Click the verification link in the email</li>
            <li>You'll be automatically logged in to your dashboard</li>
          </ol>
        </div>
        <p style={{ color: '#666', fontSize: '0.9rem', marginBottom: '2rem' }}>
          Don't see the email? Check your spam folder or wait up to 10 minutes to request another.
        </p>
        <div style={{ display: 'flex', gap: '1rem', justifyContent: 'center' }}>
          <button 
            onClick={() => navigate('/register')} 
            className="btn btn-outline"
          >
            Register Again
          </button>
          <button 
            onClick={() => navigate('/')} 
            className="btn btn-primary"
          >
            Go Home
          </button>
        </div>
      </div>
    </div>
  );
};

export default EmailVerificationPage;
